import { FC } from 'react';
import { Slider, Track, Range, Thumb } from '@radix-ui/react-slider';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledSlider = styled(Slider)`
  ${tw`relative flex items-center select-none touch-none w-full h-5`};
`;

const StyledTrack = styled(Track)`
  ${tw`bg-gray-300 absolute grow rounded-full w-full h-1`};
`;

const StyledRange = styled(Range)<{ $isActive?: boolean }>`
  ${tw`absolute bg-primary rounded-full h-full`};
`;

const StyledThumb = styled(Thumb)`
  ${tw`block w-5 h-5 bg-white border border-slate-400 shadow-sm rounded-[10px] cursor-pointer`};

  &:hover {
    ${tw`bg-primary`};
  }

  &:focus-visible {
    ${tw`outline-none border-none shadow-customFocus`};
  }
`;

interface Props {
  min?: number;
  max?: number;
  value?: [number, number];
  label?: string;
  step?: number;
  className?: string;
  handleValueChange: (value: [number, number]) => void;
}

const SliderMinMax: FC<Props> = ({
  min = 0,
  max = 10,
  step = 0.11,
  value,
  label,
  className,
  handleValueChange,
}) => {
  const onChange = (newValue: [number, number]) => {
    handleValueChange(newValue);
  };

  return (
    <StyledSlider
      min={min}
      max={max}
      value={value}
      step={step}
      className={className}
      onValueChange={onChange}
    >
      <StyledTrack>
        <StyledRange />
      </StyledTrack>
      <StyledThumb aria-label={`${label} min`} />
      <StyledThumb aria-label={`${label} max`} />
    </StyledSlider>
  );
};

export default SliderMinMax;
